import { Coffee, AlertTriangle, CheckCircle2 } from "lucide-react";
import { fmtClock, empStatus } from "./kioskUtils";

const STYLES = {
  clocked_in: { card: "bg-green-500/10 border-green-500/70 hover:bg-green-500/20", avatar: "bg-green-500 text-black" },
  on_break: { card: "bg-amber-500/10 border-amber-500/70 hover:bg-amber-500/20", avatar: "bg-amber-400 text-black" },
  late: { card: "bg-red-500/10 border-red-500 hover:bg-red-500/20 kiosk-late-pulse", avatar: "bg-red-500 text-white" },
  out: { card: "bg-neutral-900 border-neutral-800 hover:bg-neutral-800", avatar: "bg-neutral-700 text-white" },
};

const StatusLine = ({ e, status }) => {
  if (status === "clocked_in") return (
    <div className="flex items-center gap-1.5 text-green-400 text-sm mt-1" data-testid={`kiosk-emp-status-${e.id}`}>
      <CheckCircle2 size={14} /> In since {fmtClock(e.clock_in_at)}
    </div>
  );
  if (status === "on_break") return (
    <div className="flex items-center gap-1.5 text-amber-400 text-sm mt-1" data-testid={`kiosk-emp-status-${e.id}`}>
      <Coffee size={14} /> On break since {fmtClock(e.on_break_since)}
    </div>
  );
  if (status === "late") return (
    <div className="flex items-center gap-1.5 text-red-400 text-sm mt-1 font-semibold" data-testid={`kiosk-emp-status-${e.id}`}>
      <AlertTriangle size={14} /> LATE — shift {fmtClock(e.scheduled_shift?.start_at)}
    </div>
  );
  return (
    <div className="text-neutral-500 text-sm mt-1" data-testid={`kiosk-emp-status-${e.id}`}>
      {e.scheduled_shift ? `Shift ${fmtClock(e.scheduled_shift.start_at)} – ${fmtClock(e.scheduled_shift.end_at)}` : "Not clocked in"}
    </div>
  );
};

const Legend = () => (
  <div className="flex flex-wrap gap-4 text-xs text-neutral-400 mb-5" data-testid="kiosk-legend">
    <span className="flex items-center gap-1.5"><i className="w-3 h-3 rounded-full bg-green-500" /> Clocked in</span>
    <span className="flex items-center gap-1.5"><i className="w-3 h-3 rounded-full bg-amber-400" /> On break</span>
    <span className="flex items-center gap-1.5"><i className="w-3 h-3 rounded-full bg-red-500" /> Late</span>
    <span className="flex items-center gap-1.5"><i className="w-3 h-3 rounded-full bg-neutral-600" /> Not in</span>
  </div>
);

export const EmployeeGrid = ({ employees, onPick, title }) => (
  <div data-testid="kiosk-employee-picker">
    <h2 className="text-xl mb-3 text-neutral-300" data-testid="kiosk-grid-title">{title || "Tap your name to begin"}</h2>
    <Legend />
    {employees.length === 0 && <div className="text-neutral-500">No employees registered at this store yet.</div>}
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
      {employees.map((e) => {
        const status = empStatus(e);
        const s = STYLES[status];
        return (
          <button key={e.id} onClick={() => onPick(e)} data-status={status}
            className={`p-6 min-w-0 break-words border-2 rounded-lg text-lg font-semibold text-left transition-colors ${s.card}`}
            data-testid={`kiosk-emp-${e.id}`}>
            <div className={`w-14 h-14 rounded-full flex items-center justify-center text-2xl font-bold mb-3 ${s.avatar}`}>
              {(e.name || "?").trim()[0]?.toUpperCase()}
            </div>
            {e.name}
            <StatusLine e={e} status={status} />
          </button>
        );
      })}
    </div>
  </div>
);
